/**
 * Wraps specific inner text of an HTML element in <span>-Tags
 * @param range The range of the text
 */
export const wrapHighlightsWithSpan = (range: Range) => {
  const highlightNode = document.createElement("mark");
  highlightNode.className = "faq-search__highlight";

  range.surroundContents(highlightNode);
};

/**
 * Remove all tags around highlighted text
 */
export const clearHighlightNodes = () => {
  const highlightElements = document.querySelectorAll<HTMLElement>(
    ".faq-search__highlight"
  );

  for (const highlightElement of highlightElements) {
    highlightElement.replaceWith(...highlightElement.childNodes);
  }
};
